var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i-table',{staticClass:"iview_table",attrs:{"loading":_vm.isLoading,"border":"","columns":_vm.columns,"data":_vm.datas}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }